import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { formatarDataHora, type Instante } from '../../shared/dominio/datas';

interface Props {
  /** Número de 15 dígitos do assunto do aviso do SIAI. `null` = ticket sem o formato. */
  readonly numeroSiai: string | null;
  /** Mensagens vinculadas ao ticket. Mais de uma = o ticket foi atualizado. */
  readonly contagemDeMensagens: number;
  /** Chegada da mensagem mais recente (do cliente, não da triagem). */
  readonly ultimaMensagemEm: Instante | null;
}

/**
 * O número da SIAI e a marca "Atualizada" (`US-035`, `AC6`).
 *
 * Recência, não leitura: a marca diz que chegou mensagem depois da primeira, não
 * que alguém já viu. É texto escrito, nunca só cor, e não reordena a fila
 * (`S6` do `BR-004`). O número fica visível porque é o que a captadora usa
 * para falar da solicitação com a operadora.
 */
export function IdentificacaoDaSolicitacao({
  numeroSiai,
  contagemDeMensagens,
  ultimaMensagemEm,
}: Props): React.JSX.Element | null {
  const atualizada = contagemDeMensagens > 1 && ultimaMensagemEm !== null;

  if (numeroSiai === null && !atualizada) return null;

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {numeroSiai === null ? null : <Chip label={`SIAI ${numeroSiai}`} size="small" variant="outlined" />}
      {atualizada ? (
        <Chip
          label={`Atualizada · ${formatarDataHora(ultimaMensagemEm)} · ${String(contagemDeMensagens)} mensagens`}
          size="small"
          color="info"
        />
      ) : null}
    </Stack>
  );
}
